import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/documentNode';
import * as Apollo from '@apollo/client';
export const AddReactionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddReaction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idAction"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skinVariation"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"unified"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addReaction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"idAction"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idAction"}}},{"kind":"Argument","name":{"kind":"Name","value":"skinVariation"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skinVariation"}}},{"kind":"Argument","name":{"kind":"Name","value":"unified"},"value":{"kind":"Variable","name":{"kind":"Name","value":"unified"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"emoji"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"native"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"skinVariation"}},{"kind":"Field","name":{"kind":"Name","value":"unified"}}]}},{"kind":"Field","name":{"kind":"Name","value":"idEmoji"}},{"kind":"Field","name":{"kind":"Name","value":"idMember"}},{"kind":"Field","name":{"kind":"Name","value":"idModel"}},{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"AddReaction","document":AddReactionDocument}} as const;
export type AddReactionMutationVariables = Types.Exact<{
  idAction: Types.Scalars['ID']['input'];
  skinVariation?: Types.InputMaybe<Types.Scalars['String']['input']>;
  unified?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type AddReactionMutation = (
  { __typename: 'Mutation' }
  & { addReaction: (
    { __typename: 'Reaction' }
    & Pick<Types.Reaction, 'id' | 'idEmoji' | 'idMember' | 'idModel'>
    & { emoji: (
      { __typename: 'Reaction_Emoji' }
      & Pick<Types.Reaction_Emoji, 'name' | 'native' | 'shortName' | 'skinVariation' | 'unified'>
    ), member: (
      { __typename: 'Member' }
      & Pick<Types.Member, 'id' | 'fullName'>
    ) }
  ) }
);

export type AddReactionMutationFn = Apollo.MutationFunction<
  AddReactionMutation,
  AddReactionMutationVariables
>;

/**
 * __useAddReactionMutation__
 *
 * To run a mutation, you first call `useAddReactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddReactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addReactionMutation, { data, loading, error }] = useAddReactionMutation({
 *   variables: {
 *      idAction: // value for 'idAction'
 *      skinVariation: // value for 'skinVariation'
 *      unified: // value for 'unified'
 *   },
 * });
 */
export function useAddReactionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddReactionMutation,
    AddReactionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AddReactionMutation, AddReactionMutationVariables>(
    AddReactionDocument,
    options,
  );
}
export type AddReactionMutationHookResult = ReturnType<
  typeof useAddReactionMutation
>;
export type AddReactionMutationResult =
  Apollo.MutationResult<AddReactionMutation>;
export type AddReactionMutationOptions = Apollo.BaseMutationOptions<
  AddReactionMutation,
  AddReactionMutationVariables
>;
